// import { types } from "node-sass"; // wtf? delete this automatic line

export default {
  ready: state => {
    if (!state) return false; // if state is null for some reason
    if (!state.initialisedAt) return false;
    return true;
  },
  realName: state => {
    if (!state.user) return "";
    return state.user.name;
  },
  getNameAndNumber: state => {
    if (!state.user) return "Not Logged In";
    return `${state.user.name} ${state.user.phone_number}`;
  },
  lineName: state => {
    if (state.userSource == null) return "";
    return state.userSource.source_user_name;
  },
  phoneNumber: state => {
    if (!state.user) return "";
    return state.user.phone_number;
  },
  getNotificationToken: state => {
    if (!state.user) return null;
    return state.user.notification_token;
  },
  // TODO, probably should change to soundOff boolean
  isSoundOn: state => {
    if (!state.user) return true;
    if (!state.user.data) return true;
    if (state.user.data.sound === "off") return false;
    return true;
  },
  getUserMobile: state => {
    if (!state.user) return null;
    if (!state.user.phone_number) return null;
    if (state.user.phone_number.length < 7) return null;
    return state.user.phone_number;
  },
  language: state => {
    // userLanguage
    if (state.user == null) return "";
    return languageMapping(state.user.language);
  },
  getLanguage: state => {
    if (state.language) return languageMapping(state.language);
    else return "";
  },
  getAddresses: state => {
    if (!state.addresses) return [];
    return state.addresses;
  },
  // getDeliveryAddress: (getters) => {
  //   var deliveryAddress = getters.getAddresses.find(
  //     (a) => a.address_type === "delivery"
  //   );
  //   return deliveryAddress;
  // },
  getDeliveryAddress: state => {
    if (!state.addresses) return null;
    var deliveryAddress = state.addresses.find(
      a => a.address_type === "delivery"
    );
    return deliveryAddress;
  },
  // homeAddress: state => {
  //     if (!state.user || !state.addresses) return null;
  //     if (!state.addresses.length) return null;
  //     var  = state.addresses.find(a => a.address_type === 'home')
  //     if (!home) return null;
  //     return home.name
  // },
  // workAddress: state => {
  //     if (state.user == null) return '';
  //     if (state.addresses == null) return '';
  //     // var work = state.addresses.find(address => address.address_type === 'work')
  //     var address = state.addresses['work'];
  //     if (!address) return '';
  //     return address.name //"Veggiology, Soi 41"
  // },
  // deliveryAddress: state => {
  //     if (state.user == null) return '';
  //     if (state.addresses == null) return '';
  //     // var work = state.addresses.find(address => address.address_type === 'work')
  //     var address = state.addresses['delivery'];
  //     if (!address) return '';
  //     return address.name
  // },
  profilePic: state => {
    var defaultPic = require("../assets/no_profile_pic.png");
    if (state.user == null) return defaultPic;
    if (state.user.profile_pic_url !== "") return state.user.profile_pic_url;
    if (state.userSource.profile_pic_url === "") return defaultPic;
    return state.userSource.profile_pic_url;
  },
  firstCode: state => {
    if (state.magicLogin == null) return null;
    return state.magicLogin.first_code;
  },
  secondCode: state => {
    if (state.magicLogin == null) return null;
    return state.magicLogin.second_code;
  },
  magicLoginCreatedAt: state => {
    if (state.magicLogin == null) return 0;
    return new Date(state.magicLogin.created_at);
  },
  isSuperUser: state => {
    // check if user has a superuser role, right now only for TUK biz
    return state.roles.find(role => role.role_name === "Superuser"); // returns bool (obj or null)
  },
  isMagical: (state, getters) => {
    if (state.secret >= 3) return true;
    if (getters.isSuperUser) return true;
    return false;
  },
  isFreeCustomer: state => {
    return state.roles.find(role => role.role_name === "Free");
  },
  stopName: state => {
    if (!state.googlePlace) return "";
    return state.googlePlace.name;
  },
  getWorkerRoles: state => {
    return state.roles.filter(role => role.role_type === "worker");
  },
  isWorker(state, getters) {
    if (!getters.getWorkerRoles || getters.getWorkerRoles.length === 0)
      return false;
    return true;
  },
  getCustomerRoles: state => {
    return state.roles.filter(role => role.role_type === "customer");
  },
  isDriver: state => {
    return state.roles.find(role => role.role_name === "Driver");
  },
  isDispatcher: state => {
    return state.roles.find(role => role.role_name === "Dispatcher");
  },
  isAgent: state => {
    return state.roles.find(role => role.role_name === "Agent");
  },
  isDeliveryManager: state => {
    return state.roles.find(role => role.role_name === "Delivery Manager");
  },
  isDeliveryDriver: state => {
    return state.roles.find(role => role.role_name === "Delivery Driver");
  },
  isDeliveryDispatcher: state => {
    return state.roles.find(role => role.role_name === "Delivery Dispatcher");
  },
  isCommerceAgent: state => {
    return state.roles.find(role => role.role_name === "Commerce Agent");
  },
  isLogisticsAgent: state => {
    return state.roles.find(role => role.role_name === "Logistics Agent");
  },
  isAccountant: state => {
    return state.roles.find(role => role.role_name === "Accountant");
  },
  isLoggedIn: state => {
    return state.user;
  },
  getUUID: state => {
    if (state.uuid) return state.uuid.uuid;
    return "";
  },
  getUserID: state => {
    if (state.user) return state.user.id;
    return "";
  },
  getSelectedBusinessWorkflows: state => {
    if (!state.selectedBusiness) return [];
    console.log("getSelectedBusinessWorkflows", state.selectedBusiness);
    return state.selectedBusiness.workflows;
  },
  getSelectedTukTuk: state => {
    if (!state.selectedTukTuk) return null;
    return state.selectedTukTuk;
  },
  getWorkflowsPrivateTuk: state => {
    return state.workflows.filter(
      w => w.workflow_type_name === "Private Tuk Tuk"
    );
  },
  getValidWorkflowsPrivateTuk: (state, getters) => {
    return getters.getWorkflowsPrivateTuk; // previously filtered roles, should filter state
  },
  getSiilors: state => {
    return state.workflows.filter(w => w.workflow_type_name === "Sii Lor");
  },
  getSiilor: state => {
    var siilors = state.workflows.filter(
      w => w.workflow_type_name === "Sii Lor"
    );
    if (siilors.length === 0) return [];
    return siilors[0]; // hack, later need to check siilor territory
  },
  getSiilorStopsAll: (state, getters) => {
    var allStops = [];
    getters.getSiilors.forEach(s => {
      if (s.data) allStops.push(...s.data.stops);
    });
    return allStops;
  },
  getSongthaews: state => {
    return state.workflows.filter(w => w.workflow_type_name === "Songthaew");
  },
  getSongthaew: state => {
    var songthaews = state.workflows.filter(
      w => w.workflow_type_name === "Songthaew"
    );
    if (songthaews.length === 0) return [];
    return songthaews[0]; // hack, later need to check territory
  },
  getSongthaewStopsAll: (state, getters) => {
    var allStops = [];
    getters.getSongthaews.forEach(s => {
      if (s.data) allStops.push(...s.data.stops);
    });
    return allStops;
  },
  getPublicTuktuks: state => {
    return state.workflows.filter(
      w => w.workflow_type_name === "Public Tuk Tuk"
    );
  },
  getPublicTuktuk: (state, getters) => {
    if (getters.getPublicTuktuks.length === 0) return [];
    return getters.getPublicTuktuks[0]; // hack, later need to check territory
  },
  getPublicTuktukStopsAll: (state, getters) => {
    var allStops = [];
    getters.getPublicTuktuks.forEach(s => {
      if (s.data) allStops.push(...s.data.stops);
    });
    return allStops;
  },
  getTaxis: state => {
    return state.workflows.filter(w => w.workflow_type_name === "Taxi");
  },
  getTaxi: (state, getters) => {
    if (getters.getTaxis.length === 0) return [];
    return getters.getTaxis[0]; // hack, later need to check territory
  },
  getTaxiStopsAll: (state, getters) => {
    var allStops = [];
    getters.getTaxis.forEach(s => {
      if (s.data) allStops.push(...s.data.stops);
    });
    return allStops;
  },
  getMotocys: state => {
    return state.workflows.filter(w => w.workflow_type_name === "Motocy");
  },
  getMotocy: state => {
    var workflows = state.workflows.filter(
      w => w.workflow_type_name === "Motocy"
    );
    if (workflows.length === 0) return [];
    return workflows[0]; // hack, later need to check territory
  },
  getMotocyStopsAll: (state, getters) => {
    var allStops = [];
    getters.getMotocys.forEach(s => {
      if (s.data) allStops.push(...s.data.stops);
    });
    return allStops;
  },
  getUserLocationWithFallback: (state, getters) => {
    if (!state.userState) {
      // if has a selected business use that location first
      if (state.selectedBusiness) {
        var b = state.selectedBusiness; // use selectedBusiness as fallback location
        return [b.lat, b.lon];
      }
      // otherwise use IP address location as fallback << do this first?
      if (getters.getIPLatLon) {
        var ip = getters.getIPLatLon;
        return [ip.lat, ip.lon];
      }
      return null;
    }
    return [state.userState.lat, state.userState.lon];
  },
  getUserLocation: state => {
    if (!state.userState) return null;
    return [state.userState.lat, state.userState.lon];
  },
  getIPLatLon: state => {
    if (!state.ipAddress) return null;
    if (!state.ipAddress.loc) return null;
    var arr = state.ipAddress.loc.split(",");
    if (arr.length !== 2) return null;
    if (isNaN(arr[0]) || isNaN(arr[1])) return null;
    return { lat: parseFloat(arr[0]), lon: parseFloat(arr[1]) };
  },
  getUserLatLon: state => {
    if (!state.userState) return null;
    return { lat: state.userState.lat, lon: state.userState.lon };
  },
  // only used by RideBlankMap, should deprecate and use logic in getUserLocationWithFallback
  getUserLatLonWithFallback: state => {
    if (!state.userState) return { lat: 18.796143, lon: 98.979263 }; // chiang mai fallback
    return { lat: state.userState.lat, lon: state.userState.lon };
  },
  getUserLocationString: state => {
    if (!state.userState) return null;
    return `${state.userState.lat},${state.userState.lon}`; // for API
  },
  getNearestMartID: state => {
    if (!state.marts.length) return null;
    return state.marts[0].id;
  },
  getWorkingRole: state => {
    // should deprecate this... can have multiple working roles now
    return state.roles.find(role => role.state === "working");
  },
  getDeliveryDriverRole: state => {
    return state.roles.find(role => role.role_name === "Delivery Driver");
  },
  getDriverRole: state => {
    return state.roles.find(role => role.role_name === "Driver");
  },
  getDispatcherRole: state => {
    return state.roles.find(role => role.role_name === "Dispatcher");
  },
  getAgentRole: state => {
    return state.roles.find(role => role.role_name === "Agent");
  },
  getDeliveryDispatcherRole: state => {
    return state.roles.find(role => role.role_name === "Delivery Dispatcher");
  },
  geAccountantRole: state => {
    return state.roles.find(role => role.role_name === "Accountant");
  },
  getLogisticsAgentRole: state => {
    return state.roles.find(role => role.role_name === "Logistics Agent");
  },
  getCommerceAgentRole: (state, getters) => {
    var superRole = state.superRoles.find(
      r => r.active && r.role_name === "Commerce Agent"
    );
    if (superRole) return superRole;
    if (getters.getActiveCommerceAgentRole)
      return getters.getActiveCommerceAgentRole;
    if (getters.getFavoriteCommerceAgentRole)
      return getters.getFavoriteCommerceAgentRole;
    // if no active or favorite then just gets the first in array
    return state.roles.find(role => role.role_name === "Commerce Agent");
  },
  getActiveCommerceAgentRole: state => {
    if (state.activeCommerceAgentRoleID) {
      return state.roles.find(r => r.id === state.activeCommerceAgentRoleID);
    }
    return state.roles.find(r => r.active && r.role_name === "Commerce Agent");
  },
  getFavoriteCommerceAgentRole: state => {
    return state.roles.find(
      r => r.data.start_url && r.role_name === "Commerce Agent"
    );
  },
  getShops: state => {
    // return business types for shops page
    if (!state.businesses) return [];
    var arr = ["Restaurant", "Bar", "Shop"];
    if (state.shopsOrServices === "services") {
      arr = ["Service"];
    }
    return state.businesses.filter(b => arr.includes(b.business_type));
  },
  isShops: state => {
    if (state.shopsOrServices === "shops") return true;
    return false;
  },
  isServices: state => {
    if (state.shopsOrServices === "services") return true;
    return false;
  },
  driverHasOngoingPassengers: state => {
    if (!state.workerTransactions) return false;
    var arr = ["initiated", "alighted", "scheduled"];
    var ongoing = state.workerTransactions.filter(t => !arr.includes(t.state));
    if (!ongoing) return false;
    if (ongoing.length === 0) return false;
    return true;
  },
  driverHasActiveJobs: state => {
    if (!state.workerTransactions) return false;
    var arr = ["initiated", "alighted", "scheduled"]; // not active states
    return state.workerTransactions.filter(t => !arr.includes(t.state)).length;
  },
  driverHasActiveJobsNotEnroute: state => {
    if (!state.workerTransactions) return false;
    var arr = ["initiated", "alighted", "scheduled", "enroute"]; // not active states
    return state.workerTransactions.filter(t => !arr.includes(t.state)).length;
  },
  getWorkerTransactions: state => {
    if (!state.workerTransactions) return [];
    return state.workerTransactions;
  },
  getDispatcherTransactionsStateNew: state => {
    if (!state.ongoingDispatcherTransactions) return [];
    var initiated = state.ongoingDispatcherTransactions.filter(
      t => t.state === "initiated"
    );
    return initiated;
    // return initiated.filter((t) => !state.rejectedTransactions.includes(t.id));
  },
  getWorkerTransactionsStateNew: state => {
    // change state in DB from initiated to new
    if (!state.workerTransactions) return [];
    var initiated = state.workerTransactions.filter(
      t => t.state === "initiated"
    );
    return initiated.filter(t => !state.rejectedTransactions.includes(t.id));
  },
  // modified from getWorkerTransactionsStateNew to include driver settings filters
  getDriverTransactionsStateNew: (state, getters) => {
    if (!state.workerTransactions) return [];
    if (!getters.getDriverRole) return [];
    var allowPassengers = getters.getDriverRole.data.accept_passengers || "yes";
    var maxDistance = getters.getDriverRole.data.max_distance || "long";
    var maxPurchase = getters.getDriverRole.data.max_purchase || 9999;
    var boxSize = getters.getDriverRole.data.box_size || "large";
    // admin driver overrides
    var adminMaxDistance =
      getters.getDriverRole.data.admin_max_distance || 1000000; // 1000 km otherwise
    var initiated = state.workerTransactions
      .filter(t => t.state === "initiated")
      .filter(t => {
        if (t.workflow_type_name !== "Delivery") {
          if (allowPassengers === "no") return false; // not delivery means it's transport
        }
        return true;
      })
      .filter(t => {
        if (t.data.fare && t.data.fare.distance > 10000) {
          if (maxDistance === "short") return false; // not delivery means it's transport
          if (adminMaxDistance < t.data.fare.distance) return false;
        }
        return true;
      })
      .filter(t => {
        if (t.data.delivery) {
          return t.data.delivery.order_value <= maxPurchase;
        }
        return true;
      })
      .filter(t => {
        if (t.data.delivery && t.data.delivery.is_large) {
          return boxSize === "large";
        }
        return true;
      })
      .filter(t => {
        if (t.data.driver_blacklist) {
          if (t.data.driver_blacklist.includes(state.user.id)) return false;
        }
        return true; // driver not on blacklist
      });
    return initiated.filter(t => !state.rejectedTransactions.includes(t.id));
  },
  // getDriverSettings: (getters) => {
  //   return getters.getDriverRole.data; // should check this exists
  // },
  getDispatcherTransactionsStateConfirmed: state => {
    if (!state.ongoingDispatcherTransactions) return [];
    var relevant = [
      "confirmed",
      "cancelled_by_passenger",
      "driver_arrived",
      "enroute"
    ];
    return state.ongoingDispatcherTransactions.filter(t =>
      relevant.includes(t.state)
    );
  },
  getWorkerTransactionsStateConfirmed: state => {
    if (!state.workerTransactions) return [];
    var relevant = [
      "confirmed",
      "cancelled_by_passenger",
      "driver_arrived",
      "enroute"
    ];
    return state.workerTransactions.filter(t => relevant.includes(t.state));
    // return state.workerTransactions.filter(t => t.state === "confirmed" || t.state === "cancelled_by_passenger" || t.state === "driver_arrived" || t.state === "enroute")
  },
  getWorkerTransactionsStateScheduled: state => {
    if (!state.workerTransactions) return [];
    return state.workerTransactions.filter(t => t.state === "scheduled");
  },
  getWorkerTransactionsStateEnroute: state => {
    if (!state.workerTransactions) return [];
    return state.workerTransactions.filter(t => t.state === "enroute");
  },
  getWorkerTransactionsStateCancelled: state => {
    if (!state.workerTransactions) return [];
    return state.workerTransactions.filter(
      t => t.state === "cancelled_by_passenger"
    );
  },
  getOngoingWorkerTransactions: state => {
    if (!state.ongoingWorkerTransactions) return [];
    var transactions = state.ongoingWorkerTransactions;
    return transactions.filter(t => t.state != "cancelled_by_driver");
  },
  getCommerceAgentNewOrders: state => {
    if (!state.ongoingCommerceAgentTransactions) return [];
    var orders = state.ongoingCommerceAgentTransactions;
    return orders.filter(o => {
      if (o.state === "initiated") return true;
      if (o.data.autoconfirm && !o.data.event_confirmed) return true; // handle autoconfirm
      return false;
    });
    // return orders.filter(o => o.state === 'initiated')
  },
  getCommerceAgentOngoingOrders: state => {
    if (!state.ongoingCommerceAgentTransactions) return [];
    var orders = state.ongoingCommerceAgentTransactions;
    var skipStates = ["initiated", "completed", "cancelled_by_shop"];
    return orders.filter(o => {
      if (skipStates.includes(o.state)) return false;
      if (o.data.autoconfirm && !o.data.event_confirmed) return false; // handle autoconfirm
      return true;
      // return o.state !== 'initiated' && o.state !== 'completed' && o.state !== 'cancelled_by_shop'
    });
  },
  getCommerceAgentPastOrders: state => {
    if (!state.pastCommerceAgentTransactions) return [];
    return state.pastCommerceAgentTransactions; // if need to filter, var orders =
    // return state.pastCommerceAgentTransactions.filter(o => o.state === 'completed')
  },
  getLogisticsAgentNewOrders: state => {
    var orders = state.ongoingLogisticsAgentTransactions;
    if (!orders) return [];
    return orders.filter(o => o.state === "initiated");
  },
  getLogisticsAgentScheduledOrders: state => {
    var orders = state.ongoingLogisticsAgentTransactions;
    if (!orders) return [];
    return orders.filter(o => o.state === "scheduled");
  },
  getLogisticsAgentOngoingOrders: state => {
    var orders = state.ongoingLogisticsAgentTransactions;
    if (!orders) return [];
    var ignore = ["scheduled", "initiated", "completed", "cancelled_by_shop"];
    return orders.filter(o => !ignore.includes(o.state));
  },
  getLogisticsAgentPastOrders: state => {
    var orders = state.pastLogisticsAgentTransactions;
    if (!orders) return [];
    return state.pastLogisticsAgentTransactions; // if need to filter, var orders =
    // // return state.pastCommerceAgentTransactions.filter(o => o.state === 'completed')
  },
  getLogisticsAgentFleetWorkflows: state => {
    return state.logisticsAgentFleetWorkflows;
  },
  getActiveRideTransactions: state => {
    if (!state.customerTransactions) return [];
    var transactions = state.customerTransactions;
    transactions = transactions.filter(
      t => !state.endedTransactions.includes(t.id)
    );
    return transactions.filter(t => isRideTransaction(t.workflow_type_name));
  },
  // active transactions
  getCustomerTransactions: state => {
    if (!state.customerTransactions) return [];
    var transactions = state.customerTransactions;
    return transactions.filter(t => !state.endedTransactions.includes(t.id));
  },
  // active transactions minus alighted
  getCustomerTransactionsNotAlighted: state => {
    if (!state.customerTransactions) return [];
    var transactions = state.customerTransactions;
    return transactions.filter(
      t => !state.endedTransactions.includes(t.id) && t.state !== "alighted"
    );
  },
  getOngoingCustomerTransactions: state => {
    if (!state.ongoingCustomerTransactions) return [];
    var transactions = state.ongoingCustomerTransactions;
    return transactions.filter(t => t.state != "alighted");
    // return transactions.filter(t => (t.state != 'cancelled_by_passenger' && t.state != 'alighted'))
  },
  getRecentCustomerTransactions: state => {
    if (!state.recentCustomerTransactions) return [];
    return state.recentCustomerTransactions;
  },
  getLogisticsFleet: state => {
    if (!state.logisticsFleet) return [];
    return state.logisticsFleet;
  },
  getFrequentShops: state => {
    var sorted = state.shopHistory.sort((a, b) => {
      return b.count - a.count;
    });
    if (sorted.length <= 6) return sorted;
    return sorted.slice(0, 6);
  },
  getRecentShops: state => {
    var sorted = [...state.shopHistory].sort((a, b) => {
      return b.updated_at - a.updated_at;
    });
    if (sorted.length <= 5) return sorted;
    return sorted.slice(0, 5);
  },
  getDeviceLanguage: state => {
    if (!state.device) return "th";
    return state.device.language.substring(0, 2);
  },
  getOS: state => {
    if (!state.device) return "unknown";
    return state.device.os;
  },
  getBrowser: state => {
    if (!state.device) return "unknown";
    return state.device.browser;
  },
  getPWA: state => {
    if (!state.device) return false;
    return state.device.pwa;
  },
  isSafari: state => {
    if (!state.device) return false;
    return state.device.browser.toLowerCase() === "safari";
  },
  getDeviceStartURL: state => {
    if (!state.device) return null;
    return state.device.start_url;
  },
  getAdTag: state => {
    if (!state.device) return null;
    return state.device.ad_tag;
  },
  getReferralCode: state => {
    if (!state.device) return null;
    return state.device.referral_code;
  },
  getPreviousRoute: state => {
    if (state.routeHistory.length < 2) return null;
    var idx = state.routeHistory.length - 2;
    return state.routeHistory[idx];
  },
  getPreviousPreviousRoute: state => {
    if (state.routeHistory.length < 3) return null;
    var idx = state.routeHistory.length - 3;
    return state.routeHistory[idx];
  },
  isPassenger: (state, getters) => {
    // if (!state.customerTransactions) return false
    if (getters.getCustomerTransactions.length > 0) return true;
    return false;
  },
  getUnreadMessages: state => {
    if (!state.messages) return [];
    return state.messages.filter(m => m.state === "unread");
  },
  getStartURL: state => {
    var r = state.roles.find(r => r.data.start_url);
    if (r) return r.data.start_url;
    return null;
  },
  getCurrentVersionNumeric: state => {
    if (typeof state.version == "string") {
      return parseFloat(state.version.slice(0, -1));
    }
    return state.version;
  },
  getFavoriteEateries: state => {
    return state.eateries.filter(e => state.favorites.find(f => f === e.id));
  }
};

function languageMapping(code) {
  // if (code === 'en') return "English"
  switch (code) {
    case "en":
      return "English";
    case "th":
      return "ภาษาไทย";
    case "ja":
      return "日本語";
    case "zh":
      return "汉语";
    case "my":
      return "မြန်မာစာ";
    case "kh":
      return "ភាសាខ្មែរ";
    default:
      return "English";
  }
}

function isRideTransaction(workflowType) {
  var arr = [
    "Fleet",
    "Private Tuk Tuk",
    "Public Tuk Tuk",
    "Songthaew",
    "Sii Lor",
    "Taxi",
    "Motocy"
  ];
  return arr.includes(workflowType);
}
